module.exports = __webpack_public_path__ + "static/horizons02-096346574c47f66b0a884cee9f2a6139.png";